import { FieldType, ModelInfo } from './__ModelInfo'
import { Types } from '../types'
import { BaseClass } from './__base'
import { formField, linkedFormField } from '../../utils/decorators'
import { IFormEvents, FormEvent } from '../../components/Form/model'

const Model = new ModelInfo({
	model: {
		uid: Types.TILE_CONTENT,
		name: 'Tile content'
	},
	fields: []
})

export class TileContent extends BaseClass implements IFormEvents {
	public static model = Model
	public static folderId = 3

	public disabledFields(): string[] {
		return []
	}

	constructor(item: any = {}) {
		super(item)
	}

	public formOnRenderField(evt: FormEvent): boolean {
		const { fieldUID, state } = evt

		if (
			state.values.isHeroImage &&
			(fieldUID === 'title' || fieldUID === 'link')
		) {
			return false
		}

		return true
	}

	@formField({
		fieldtype: FieldType.File,
		flags: { required: true, multiple: false },
		name: 'Image',
		config: {
			uploadURL: '/fileInFolder',
			body: 'tile-content'
		},
		validations: [
			{
				type: FieldType.File,
				config: {
					maxSize: 5000000,
					allow: 'jpeg,JPEG,jpg,JPG,png,PNG,jpe,JPE,jfif,JFIF'
				}
			}
		]
	})
	public image: string = ''

	@formField({
		fieldtype: FieldType.Boolean,
		name: 'Add as Hero Image'
	})
	public isHeroImage: boolean = false

	@linkedFormField('isHeroImage')
	@formField({
		fieldtype: FieldType.Text,
		flags: { dummyRequired: true },
		name: 'Title',
		validations: [
			{
				type: FieldType.Text,
				config: {
					maxLen: 30
				}
			}
		]
	})
	public title: string = ''

	@formField({
		fieldtype: FieldType.Text,
		name: 'Description',
		config: { isMultiline: true },
		validations: [
			{
				type: FieldType.Text,
				config: {
					maxLen: 210
				}
			}
		]
	})
	public description: string = ''

	@formField({
		fieldtype: FieldType.Text,
		flags: { required: true },
		name: 'Alternative Text',
		validations: [
			{
				type: FieldType.Text,
				config: {
					maxLen: 30
				}
			}
		]
	})
	public alternativeText: string = ''

	@linkedFormField('isHeroImage')
	@formField({
		fieldtype: FieldType.Text,
		flags: { dummyRequired: true },
		name: 'Link',
		validations: [
			{
				type: FieldType.Text,
				config: {
					maxLen: 480
				}
			}
		]
	})
	public link: string = ''

	public formOnValidate(evt: FormEvent): any {
		const errors: any = {}

		const errorMessage = 'This field is mandatory.'

		if (!evt.state.values.image) {
			errors['image'] = errorMessage
		}

		if (!evt.state.values.alternativeText) {
			errors['alternativeText'] = errorMessage
		}

		if (!evt.state.values.title && !evt.state.values.isHeroImage) {
			errors['title'] = errorMessage
		}

		if (!evt.state.values.link && !evt.state.values.isHeroImage) {
			errors['link'] = errorMessage
		}

		return errors
	}
}
